<script setup lang="ts">
import { ActivityDetailsModalType } from '../models';
import { useActivityDetailsModalsStore } from '../stores';

import TicketsSelectorModal from './ticketsSelector/TicketsSelectorModal.vue';

const activityDetailsModalsStore = useActivityDetailsModalsStore();
</script>

<template>
  <TicketsSelectorModal
    v-if="
      activityDetailsModalsStore.activityDetailsModalType ===
      ActivityDetailsModalType.TicketsSelection
    "
  />
</template>

<style scoped lang="scss"></style>
